import { Observable } from 'rxjs';
import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import { GuestModel, AuthModel } from '@models';
import { Router } from '@angular/router';

import { appHttpClient } from '@framework';
import { environment as env } from 'environments/environment';

import { ErrorHandler } from './error.services';

@Injectable()
export class AuthServices {
    @Output() onAuthorized = new EventEmitter();
    private get _endpoint() { return env.authURL + '/login' }

    constructor(
        @Inject('appHttpClient') private _HttpClient: appHttpClient,
        private _router: Router
    ) { }

    public Register(_guest: GuestModel) {
        this._HttpClient.Post(this._endpoint + '/register/local', _guest.toJSONData())
            .map(res => <AuthModel>res.json())
            .subscribe(
                (_data: AuthModel) => { this._postLogin(_data); }
                , ErrorHandler
            );
    }

    public Login(_guest: GuestModel) {
        return new Observable((_operator) => {
            this._HttpClient.Post(this._endpoint, _guest.toJSONData())
                .map(res => <AuthModel>res.json())
                .subscribe(
                    (_data: AuthModel) => {
                        this._postLogin(_data);
                        _operator.next();
                    }, (_error) => {  _operator.error(_error); }
                );
        });
    }

    _postLogin(_auth: AuthModel) {
        localStorage.setItem('AuthToken', _auth.AuthToken);
        if (_auth.AuthSalt) {
            this._postAuthorization(_auth)
        } else {
            this._startVerification()
        }
    }

    public Verify(_AuthCode) {
        return new Observable((_operator) => {
            this._HttpClient.Get(this._endpoint + '/otp/' + _AuthCode)
                .map(res => <AuthModel>res.json())
                .subscribe(
                    (_data: AuthModel) => {
                        this._postAuthorization(_data);
                        _operator.next();
                    }, (_error) => { _operator.error(_error); }
                );
        });
    }

    _postAuthorization(_auth: AuthModel) {
        localStorage.setItem('AuthToken', _auth.AuthToken);
        localStorage.setItem('AuthSalt', _auth.AuthSalt);
        localStorage.setItem('isPassExpired', _auth.isPassExpired);
        this._startApp()
    }


    ResetPassword(_passwords) {
        let _endpoint = this._endpoint + '/SetExpiredPassword';
        return this._HttpClient.Post(_endpoint, JSON.stringify(_passwords))
          .map((res) => res.json());
      }



    public UnLock(_guest: GuestModel) {
        return new Observable((_operator) => {
            this._HttpClient.Post(this._endpoint + '/unlock', _guest.toJSONData())
                .map(res => <AuthModel>res.json())
                .subscribe(
                    (_data: AuthModel) => {
                        this._postUnLock(_data);
                        _operator.next();
                    }, (_error) => { _operator.error(_error); }
                );
        });
    }

    _postUnLock(_auth: AuthModel) {
        localStorage.setItem('AuthToken', _auth.AuthToken);
        localStorage.setItem('AuthSalt', _auth.AuthSalt);
        //this._startApp()
    }


    _startLogin() { this._router.navigate(['login']); }

    _startVerification() { this._router.navigate(['verification']); }

    _startApp() {
        this.onAuthorized.emit();
        this._router.navigate(['startapp']);
    }

    _startAppHomePage() {

        //console.log(this._userServices.getLoggedInUser())
        //TODO: Get the loggedInUser and Load their Dashboard based on their Project
        // i.e ims/dashboard --See if we can develop multi dashboard connected to usergroup/userrole
        // or get the defined dashboard in current user Menu
        this._router.navigate(['dashboard'])
        
        //TODO NEED MORE TESTING
        //const _RedirectURL = localStorage.getItem('RedirectURL');
        // console.log(_RedirectURL)
        //this._router.navigate([_RedirectURL])


    }



    public isAuthenticated() {
        //this.RefreshSession();
        const _authToken = localStorage.getItem('AuthToken');
        const _isAuthenticated = _authToken !== null;
        return _isAuthenticated;
    }

    public isAuthorized() {
        //this.RefreshSession();
        const _authToken = localStorage.getItem('AuthToken');
        const _authSalt = localStorage.getItem('AuthSalt');
        const _isAuthenticated = _authToken !== null;
        const _isAuthorized = _authSalt !== null;
        return (_isAuthenticated && _isAuthorized);
    }


    public isPassExpired() {
        return new Observable((_operator) => {
            const _isPassExpired = localStorage.getItem('isPassExpired') || false;
            _operator.next(_isPassExpired);
        });
    }


    public GetAuthenticatedUser() { //GET Current Logged In User
        return this._HttpClient.Get(env.authURL + "/user/me")
            .map((res) => res.json());
    }

}


// // =================================================================================================
// // GUARDIANS SECTION
// // =================================================================================================

// //Auth Guard has AthToken and AuthSalt ( Complete Authentication and Authorization )
// //Used for All Components that Required Both Authentication and authorization
// //Otherwise Redirect all Request to LOGIN Page
// @Injectable()
// export class AuthGuard implements CanActivate {

//     constructor(
//         @Inject('AuthServices') private _authServices: AuthServices,
//         private _router: Router) { }

//     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//         const _isAuth = this._authServices.isAuthorized();
//         if (!_isAuth) {
//             this._router.navigate(['login']);
//         }
//         return _isAuth;
//     }
// }

// @Injectable()
// export class LoggedGuard implements CanActivate {

//     constructor(
//         @Inject('AuthServices') private _authServices: AuthServices,
//         private _router: Router) { }

//     canActivate() {
//         const _isAuth = this._authServices.isAuthorized();
//         if (_isAuth) {
//             this._router.navigate(['startapp']);
//         }
//         return !_isAuth;
//     }
// }

// //Lock Guard has only AthToken and NO AuthSalt
// //Used for Components that Required to Re-authorized in order to get the AuthSalt
// //Such as LockScreen or Authorization Page
// @Injectable()
// export class LockGuard implements CanActivate {

//     constructor(
//         @Inject('AuthServices') private _authServices: AuthServices,
//         private _router: Router) { }

//     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//         const _isAuth = this._authServices.isAuthenticated();
//         if (!_isAuth) {
//             this._router.navigate(['login']);
//         }
//         return _isAuth;
//     }
// }
